import React, { CSSProperties, useCallback } from "react";
import { VelavuSwitchDisplay } from "./velavu-switch";
import * as styles from "./velavu-switch-block.module.scss";
import { classArr } from "../helper/style-helper";

export interface VelavuSwitchBlockProps {
	style?: CSSProperties;
	className?: string;

	toggled: boolean;
	onChange?: (toggled: boolean) => void;
	label: string;
	disabled?: boolean;

	children?: React.ReactNode;
}

export default function VelavuSwitchBlock(props: VelavuSwitchBlockProps) {
	const { onChange: propsOnChange, toggled, disabled } = props;
	const onClick = useCallback(() => {
		propsOnChange?.(!toggled);
	}, [propsOnChange, toggled]);

	return (
		<div
			style={props.style}
			className={classArr(styles.container, props.className)}
		>
			<button
				className={classArr(
					styles.button,
					props.children && props.toggled && styles.buttonTop,
					disabled && styles.buttonDisabled,
				)}
				onClick={onClick}
				disabled={disabled}
			>
				<span
					className={classArr(
						styles.label,
						props.toggled
							? styles.labelChecked
							: styles.labelUnchecked,
					)}
				>
					{props.label}
				</span>
				<VelavuSwitchDisplay
					toggled={props.toggled}
					disabled={disabled}
				/>
			</button>

			{props.children}
		</div>
	);
}
